@if (visibleSteps().length > 0) {
  <div class="wz" role="group" aria-label="Wizard">
    <!-- Step Bar -->
    <div class="wz-header">
      <app-wizard-step-bar
        [items]="stepBarItems()"
        [ariaLabel]="'Step navigation'"
        (stepClick)="goToStep($event)" />
    </div>

    <!-- Content Area — all steps rendered, inactive hidden to preserve state -->
    <div class="wz-content">
      @for (step of visibleSteps(); track step.stepId(); let i = $index) {
        <div class="wz-step-panel"
             [class.wz-slide-forward]="i === activeStepIndex() && slideDirection() === 'forward'"
             [class.wz-slide-backward]="i === activeStepIndex() && slideDirection() === 'backward'"
             [hidden]="i !== activeStepIndex()"
             role="tabpanel"
             [attr.aria-label]="step.stepLabel()">
          <ng-container *ngTemplateOutlet="step.templateRef" />
        </div>
      }
    </div>

    <!-- Footer (projected) -->
    <footer class="wz-footer">
      <ng-content select="[wizardFooter]" />
    </footer>
  </div>
}
